import Backend from "shared/lib/Backend";
import queryString from "query-string";

export default (
  q,
  tags = [],
  page = 0,
  collection_id = null
) => async dispatch => {
  const collectionParam = collection_id ? { collection_id } : {};
  const searchParam = q ? { q } : {};
  const tagsParam = tags && tags.length > 0 ? { tags } : {};
  const pageParam = page > 0 ? { page } : {};

  let queryParams = {
    ...collectionParam,
    ...searchParam,
    ...pageParam,
    ...tagsParam
  };

  let query = queryString.stringify(queryParams, { arrayFormat: "bracket" });

  let url = `${window.location.pathname}/collections`;

  if (query) url = `${url}?${query}`;

  const response = await Backend.get(url, {
    headers: { Accept: "application/json" }
  });

  const type = page > 0 ? "COLLECTIONS/APPEND" : "COLLECTIONS/REPLACE";
  dispatch({ type: type, data: response });
};
